<template>
  <div class="flex item-center gap-2 mb-4">
    <div class="relative w-full">
      <el-input class="w-full" placeholder="Search here" v-model="searchTerm" />

      <div class="absolute mr-4 setinpuicon" v-if="searchTerm.length == 0">
        <feather-icon
          icon="SearchIcon"
          svgClasses="h-6 w-6"
          class="text-primary"
        />
      </div>
    </div>
    <div
      class="absolute setinpuicon"
      v-if="searchTerm.length > 0"
      @click="resetSearchTerm"
    >
      <feather-icon icon="XIcon" svgClasses="h-6 w-6  cursor-pointer" />
    </div>
    <!-- </div> -->
    <!-- <div class="w-3/12">
      <el-select
        v-model="selectedData"
        placeholder="Select"
        @change="filterStatus(selectedData)"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      options: [
        {
          value: "All",
          label: "All",
        },
        {
          value: "Open",
          label: "Open",
        },
        {
          value: "Pending",
          label: "Pending",
        },
        {
          value: "Closed",
          label: "Closed",
        },
      ],
      selectedData: "",
    };
  },
  computed: {
    ...mapState("whatsappChat", {
      search: "searchTerm",
      contacts: "contacts",
      filterContact: "filterContact",
    }),

    searchTerm: {
      get() {
        return this.search;
      },
      set(val) {
        this.$store.commit("whatsappChat/SET_SEARCH_TERM", val);
      },
    },
  },
  watch: {
    search(val) {
      this.searchResults();
    },
  },
  methods: {
    resetSearchTerm() {
      this.searchTerm = "";
    },
    debounce(func, ms = 0) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), ms);
      };
    },
    searchResults() {
      if (this.searchTerm.length > 0) {
        this.debounce(this.fuzzySearch(this.contacts), 250);
      }
    },
    fuzzySearch(dataset) {
      let results = dataset.filter((val) => {
        const str = this.search;
        const num = Number(str);
        const isnumber = !isNaN(num);
        if (isnumber) {
          return val.phone.includes(this.search);
        } else {
          return val.name.toLowerCase().includes(this.search);
        }
      });

      this.$store.commit("whatsappChat/SET_SEARCH_RESULTS", results);
    },
    // async filterStatus(datas) {
    //   if (datas === "All") {
    //     let emptyArray = [];
    //     await this.$store.commit("whatsappChat/SET_FILTER_RESULT", emptyArray);
    //   } else {
    //     console.log(this.contacts);
    //     const payload = {
    //       status: datas,
    //     };
    //     let { data } = await this.$store.dispatch(
    //       "AgentRouting/statusFilter",
    //       payload
    //     );
    //     if (data) {
    //       // this.$store.commit("whatsappChat/SET_FILTER_RESULT", data);
    //       let result = [];
    //       for (let i = 0; i < data.length; i++) {
    //         let results = this.contacts.filter((val) => {
    //           // console.log(val);
    //           const str = data[i].number;
    //           const num = Number(str);
    //           const isnumber = !isNaN(num);

    //           return val.phone.includes(data[i].number);
    //         });
    //         if (results[0]) {
    //           result.push(results[0]);
    //         }
    //       }
    //       console.log(result);
    //       await this.$store.commit("whatsappChat/SET_FILTER_RESULT", result);
    //       console.log(this.filterContact, "ukheiud");
    //     }
    //   }
    // },
  },
};
</script>
